import { lazy } from "react";
import { ALLOWED_MODULES } from "../../constants/enums";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { CAMPAIGN_ROUTE } from "./campaign.constant";

// Lazy imports
const CampaignList = Loadable(
  lazy(() =>
    import("./CampaignList").then(({ CampaignList }) => ({
      default: CampaignList,
    }))
  )
);

const ManageCampaign = Loadable(
  lazy(() =>
    import("./ManageCampaignList").then(({ ManageCampaignList }) => ({
      default: ManageCampaignList,
    }))
  )
);

export const campaignRoutes = [
  {
    path: CAMPAIGN_ROUTE,
    element: (
      <AuthorizedRoute
        allowFullAccess
        moduleIds={[ALLOWED_MODULES.CAMPAIGN]}
      >
        <CampaignList />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${CAMPAIGN_ROUTE}/manage`,
    element: (
      <AuthorizedRoute
        allowFullAccess
        moduleIds={[ALLOWED_MODULES.CAMPAIGN]}
      >
        <ManageCampaign />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${CAMPAIGN_ROUTE}/manage/:uuid`,
    element: (
      <AuthorizedRoute
        allowFullAccess
        moduleIds={[ALLOWED_MODULES.CAMPAIGN]}
      >
        <ManageCampaign />
      </AuthorizedRoute>
    ),
  },
];
